import * as actions from '../actions/types'

const initialState = {
  confirmations: [
    {
      id: 'deltaEmail',
      status: false
    },
    {
      id: 'timelines',
      status: false
    },
    {
      id: 'eligibility',
      status: false
    },
    {
      id: 'documentation',
      status: false
    },
    {
      id: 'faq',
      status: false
    },
    {
      id: 'application',
      status: false
    },
    {
      id: 'changes',
      status: false
    },
    {
      id: 'accurate',
      status: false
    },
    {
      id: 'disqualification',
      status: false
    }
  ],
  status: 'IN',
  upgradeOption: false,
  passcode: ''
};

function toggleConfirmation(formState, action) {
  return {
    ...formState,
    confirmations: formState.confirmations.map(confirmation => confirmation.id === action.id ? { ...confirmation, status: !confirmation.status} : confirmation)
  };
}

function setStatus(applicationState, action) {
  return {
    ...applicationState,
    status: action.status
  }
}

function setApplication(applicationState, action) {
  return {
    ...applicationState,
    status: action.application.status,
    upgradeOption: !!action.application.upgradeOption
  }
}

function applicationDeleted() {
  return initialState;
}

function toggleUpgradeOption(applicationState) {
  return {
    ...applicationState,
    upgradeOption: !applicationState.upgradeOption
  }
}

function setUpgradeOption(applicationState, action) {
  return {
    ...applicationState,
    upgradeOption: action.upgradeOption
  }
}

function setPasscode(applicationState, { passcode }) {
  return {
    ...applicationState,
    passcode
  }
}

export const applicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.TOGGLE_CONFIRMATION:
      return toggleConfirmation(state, action);
    case actions.SET_APPLICATION_STATUS:
      return setStatus(state, action);
    case actions.SET_APPLICATION:
    case actions.REFRESH_APPLICATION:
      return setApplication(state, action);
    case actions.DELETE_APPLICATION_SUCCESS:
      return applicationDeleted();
    case actions.TOGGLE_UPGRADE_OPTION:
      return toggleUpgradeOption(state);
    case actions.SET_UPGRADE_OPTION:
      return setUpgradeOption(state, action);
    case actions.SET_PASSCODE:
      return setPasscode(state, action);
    default:
      return state;
  }
};

export default applicationReducer;